import { useState, useEffect } from 'react';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function AgentPerformanceDashboard({ agentId, startDate, endDate }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, [agentId, startDate, endDate]);

  const fetchStats = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams({
        start_date: startDate || new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
        end_date: endDate || new Date().toISOString()
      });

      const response = await axios.get(
        `${API_BASE}/dialer/reports/agent/${agentId}?${params}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching agent stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-4">Loading performance data...</div>;
  }

  if (!stats) {
    return <div className="text-center py-4 text-gray-500">No data available</div>;
  }

  const chartData = [
    { name: 'Answered', value: parseInt(stats.answered_calls || 0) },
    { name: 'No Answer', value: parseInt(stats.no_answer_calls || 0) },
    { name: 'Busy', value: parseInt(stats.busy_calls || 0) },
    { name: 'Failed', value: parseInt(stats.failed_calls || 0) }
  ];

  return (
    <div className="bg-white rounded-lg shadow p-6 space-y-6">
      <h3 className="text-xl font-semibold">Agent Performance</h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <p className="text-sm text-gray-600">Total Calls</p>
          <p className="text-2xl font-bold">{stats.total_calls || 0}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Answered</p>
          <p className="text-2xl font-bold text-green-600">{stats.answered_calls || 0}</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Avg Duration</p>
          <p className="text-2xl font-bold">{Math.round(stats.avg_duration || 0)}s</p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Answer Rate</p>
          <p className="text-2xl font-bold">{Math.round(stats.answer_rate || 0)}%</p>
        </div>
      </div>

      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#3b82f6" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}


